(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssignmentsController', AssignmentsController);

  /* ngInject */
  function AssignmentsController($state, $stateParams, Flash, assignmentService, sessionService, vendorService, vmsUserService) {
    const vm = this;

    vm.assignments = [];
    vm.createAssignment = createAssignment;
    vm.deleteAssignment = deleteAssignment;
    vm.vendorId = $stateParams.vendorId;
    vm.users = [];
    vm.vendor = {};

    activate();

    function activate() {
      getAssignments();
      getUsers();
      getVendor();
    }

    function createAssignment() {
      assignmentService(sessionService.getAuthToken()).create({ vendorId: vm.vendorId }, vm.assignment, _ => {
        $state.reload();
        Flash.create('success', 'Assignment successfully created.');
      }, _ => {
        Flash.create('danger', 'An issue occurred with the submission. Please try again later.');
      });
    }

    function deleteAssignment(assignment) {
      assignmentService(sessionService.getAuthToken()).destroy({ vendorId: vm.vendorId, id: assignment.id }, _ => {
        $state.reload();
        Flash.create('succcess', 'Assignment successfully deleted.');
      }, _ => {
        Flash.create('danger', 'An issue occurred with the submission. Please try again later.');
      });
    }

    function getAssignments() {
      assignmentService(sessionService.getAuthToken()).query({ vendorId: vm.vendorId }, response => vm.assignments = response);
    }

    function getUsers() {
      vmsUserService(sessionService.getAuthToken()).query(response => vm.users = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }
  }
})();
